import { AvantiCardRunsContainer } from "./container";
import { PageFrame } from "../../components/page_frame";

export const AvantiCardRunsPage = () => {
  return (
    <PageFrame>
      <AvantiCardRunsContainer />
    </PageFrame>
  );
};
